import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isAuthorized } = useAuth();

  if (!isAuthenticated) { 
    return <Redirect to="/login" />;
  }else{
    if (!isAuthorized)
       return <Redirect to="/forbidden" />

    console.log("Utente autorizzato");
  }

  return (
    <>
      {children}
    </>
  );
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
